import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {PageBreadCrumb} from '../../../page/config/page-config.type';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [RouterLink]
})
export class BreadcrumbComponent {
    items = input.required<PageBreadCrumb[]>();
}
